import { useNavigate } from "react-router-dom";
import React from "react";
import { Context } from "../../context/Contexts";
import { useDispatch } from "react-redux";
import { updateuserinfo } from "../../redux/userRedux";

export const Logout = () => {
    const navigate = useNavigate();
    const { dispatch } = React.useContext(Context);
    const userDispatch = useDispatch();

    React.useEffect(() => {
        dispatch({ type: "LOGOUT" });
        userDispatch(updateuserinfo(null));
        localStorage.clear();
        navigate('/', { replace: true });
    }, [dispatch, userDispatch, navigate]);

    return null;
};

export default Logout;
